<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn" id="plannedPeriodsRoot">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Period Planner
                    </div>
                    <div class="card-block">
                        <div class="row">
                            <div class="col-md-4">
                                <select :disabled="projectId" class="form-control" v-model="newVacation.project_id">
                                    <option :value="null" disabled hidden>Select project</option>
                                    <option v-for="project in projects" :value="project.id">{{project.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <select class="form-control" v-model="newVacation.type">
                                    <option :value="null" disabled hidden>Select type</option>
                                    <option v-for="plan in planTypes" :value="plan.type">{{plan.type}}</option>
                                </select>
                            </div>
                            <div v-if="newVacation.type == 'Employee' || !newVacation.type" class="col-md-4">
                                <select class="form-control" v-model="newVacation.user_id">
                                    <option :value="null" disabled hidden>Select user</option>
                                    <option v-for="user in activeUsers" :value="user.id">{{user.displayName}}</option>
                                </select>
                            </div>
                            <div v-if="newVacation.type == 'Material'" class="col-md-4">
                                <input class="form-control" v-model="newVacation.materialName" placeholder="Material name">
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-4">
                                <datepicker placeholder="yyyy-mm-dd" input-class="new-vacation-date-picker" v-model="newVacation.starts_at" format="yyyy-MM-dd"></datepicker>
                            </div>
                            <div class="col-md-4">
                                <datepicker :disabled="!newVacation.starts_at" :disabled-dates="{to: new Date(newVacation.starts_at)}" placeholder="yyyy-mm-dd" input-class="new-vacation-date-picker" v-model="newVacation.ends_at" format="yyyy-MM-dd"></datepicker>
                            </div>
                            <div class="col-md-4">
                                <input v-model="newVacation.coefficient" class="form-control" type="number" min="0" max="1" step="0.1" :placeholder="(newVacation.type == 'Employee' || ! newVacation.type) ? 'Coefficient' : 'Material sum'">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-6">
                                <button class="btn btn-primary" :disabled="vacationSaveProcess" @click="createVacation">Save</button>
                            </div>
                            <div v-if="newVacation.type == 'Employee' || !newVacation.type" class="col-md-6">
                                <div class="col-md-5 pr-0 float-right">
                                    <div class="input-group">
                                        <span class="input-group-btn">
                                            <button type="button" class="btn btn-primary" @click="calculateVacationExpenses(newVacation)"><i class="fa fa-rotate-right"></i></button>
                                        </span>
                                        <input disabled type="text" v-model="newVacationExpenses" class="form-control" placeholder="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Planned periods
                    </div>
                    <div class="card-block">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <label class="col-form-label">Start date</label>
                                <div class="col-md-3">
                                    <datepicker :typeable="true" placeholder="yyyy-mm-dd" :disabled-dates="{from: new Date(filterDate.end)}" input-class="new-vacation-date-picker" v-model="filterDate.start" format="yyyy-MM-dd"></datepicker>
                                </div>
                                <label class="col-form-label">End date</label>
                                <div class="col-md-3">
                                    <datepicker :typeable="true" :disabled="!filterDate.start" :disabled-dates="{to: new Date(filterDate.start)}" placeholder="yyyy-mm-dd" input-class="new-vacation-date-picker" v-model="filterDate.end" format="yyyy-MM-dd"></datepicker>
                                </div>
                            </div>
                        </div>
                        <table class="table table-striped compact">
                            <thead>
                                <th>#</th>
                                <th>Project</th>
                                <th>User</th>
                                <th>Start date</th>
                                <th>End date</th>
                                <th>Hours</th>
                                <th>Costs</th>
                                <th>Coefficient</th>
                                <th>Actions</th>
                            </thead>
                            <tbody>
                                <tr v-for="plannedVacation in plannedVacations" :key="plannedVacation.id" v-if="showVacation(plannedVacation)">
                                    <td>{{plannedVacation.id}}</td>
                                    <td>{{projects ? projects[plannedVacation.project_id].name : ''}}</td>
                                    <td>{{users[plannedVacation.user_id].displayName}}</td>
                                    <td>{{plannedVacation.starts_at}}</td>
                                    <td>{{plannedVacation.ends_at}}</td>
                                    <td class="hours">{{plannedVacation.hours ? numberWithSpaces(plannedVacation.hours.toFixed(2)) : 0.00}}</td>
                                    <td class="currency">{{plannedVacation.costs ? numberWithSpaces(plannedVacation.costs.toFixed(2)) : 0.00}}</td>
                                    <td>{{plannedVacation.coefficient}}</td>
                                    <td>
                                        <i @click="openEditVacation(plannedVacation.id)" class="fa fa-lg fa-pencil-square-o action" aria-hidden="true"></i>
                                        <i @click="deleteVacation(plannedVacation.id)" class="fa fa-lg fa-trash action" aria-hidden="true"></i>
                                    </td>
                                </tr>
                                <tr class="total-costs-row">
                                    <td colspan="5">Total</td>
                                    <td class="hours">{{tableTotal.hours ? numberWithSpaces(tableTotal.hours.toFixed(2)) : 0.00}}</td>
                                    <td class="currency" colspan="3">{{tableTotal.costs ? numberWithSpaces(tableTotal.costs.toFixed(2)) : 0.00}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div><!--/.col-->
        </div><!--/.row-->
        <modal title="Modal title" v-model="editVacationModal" @ok="saveVacation" class="z-100" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">Edit Project</h4>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Project</label>
                <div class="col-md-9">
                    <select class="form-control" v-model="editVacation.project_id">
                        <option v-for="project in projects" :value="project.id">{{project.name}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">User</label>
                <div class="col-md-9">
                    <select class="form-control" v-model="editVacation.user_id">
                        <option v-for="user in activeUsers" :value="user.id">{{user.displayName}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Start date</label>
                <div class="col-md-9">
                    <datepicker placeholder="yyyy-mm-dd" input-class="new-vacation-date-picker" v-model="editVacation.starts_at" format="yyyy-MM-dd"></datepicker>
                    <!--<input v-model="editVacation.starts_at" class="form-control" type="date" title="Start date" :max="editVacation.ends_at">-->
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">End date</label>
                <div class="col-md-9">
                    <datepicker placeholder="yyyy-mm-dd" input-class="new-vacation-date-picker" v-model="editVacation.ends_at" format="yyyy-MM-dd"></datepicker>
                    <!--<input v-model="editVacation.ends_at" class="form-control" type="date" title="End date" :min="editVacation.starts_at">-->
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Coefficient</label>
                <div class="col-md-9">
                    <input v-model="editVacation.coefficient" class="form-control" type="number" min="0" max="1" step="0.1" placeholder="Coefficient">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Expenses</label>
                <div class="col-md-9">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-primary" @click="calculateVacationExpenses(editVacation)"><i class="fa fa-rotate-right"></i></button>
                        </span>
                        <input disabled type="text" v-model="editVacationExpenses" class="form-control" placeholder="">
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import VueNotifications from 'vue-notifications';
import modal from 'vue-strap/src/Modal';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'VacationPlanner',
  props: ['projectId'],
  data: function () {
    return {
      newVacation: {
        type: null,
        project_id: this.projectId || null,
        user_id: null,
        starts_at: null,
        ends_at: null,
        coefficient: null,
        materialName: '',
      },
      newVacationExpenses: '0 h / 0 €',
      editVacationExpenses: '0 h / 0 €',
      editVacation: {},
      editVacationModal: false,
      calculatedVacationsExpenses: '',
      tableTotal: {
        hours: 0,
        costs: 0
      },
      planTypes: [
        {
          type: 'Employee'
        },
        {
          type: 'Material'
        }
      ],
      filterDate: {
        start: '',
        end: ''
      },
      vacationSaveProcess: false
    };
  },
  components: {
    modal,
    Datepicker
  },
  watch: {
    filterDate: {
      handler: function (val) {
        this.calculateAllVacationsExpenses();
      },
      deep: true
    },
    editVacationModal: function (val) {
      if (val) {
        $('#plannedPeriodsRoot').parent().css('z-index', 3000);
      } else {
        setTimeout(() => {
          $('#plannedPeriodsRoot').parent().css('z-index', 0);
        }, 300);
      }
    },
    plannedVacations: {
      handler: function () {
        this.calculateAllVacationsExpenses();
      },
      deep: true
    },
    projectId: {
      immediate: true,
      handler: function (val) {
        this.newVacation.project_id = this.projectId;
      }
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  computed: {
    ...mapGetters('PlannedVacations', ['plannedVacations']),
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('JiraUsers', ['users', 'activeUsers']),
    ...mapGetters('UserRates', ['ratesByUser', 'ratesOnDate']),
    ...mapGetters('SpecialBusinessDays', ['specialBusinessDays'])
  },
  methods: {
    ...mapActions('PlannedVacations', ['LOAD_PLANNED_VACATIONS', 'CREATE_PLANNED_VACATION', 'DELETE_PLANNED_VACATION']),
    ...mapActions('ProjectMaterials', ['CREATE_PLANNED_PROJECT_MATERIALS']),
    createVacation() {
      const _this = this;
      this.vacationSaveProcess = true;
      if (this.newVacation.type == 'Employee' || !this.newVacation.type) {
        this.newVacation.starts_at = moment(this.newVacation.starts_at).format('YYYY-MM-DD');
        this.newVacation.ends_at = moment(this.newVacation.ends_at).format('YYYY-MM-DD');
        this.CREATE_PLANNED_VACATION(this.newVacation).then(() => {
          _this.newVacation = {
            type: null,
            project_id: _this.projectId || null,
            user_id: null,
            starts_at: null,
            ends_at: null,
            coefficient: null,
            materialName: '',
          };
          _this.vacationSaveProcess = false;
          _this.showSuccessMsg({ title: 'Planned period create status', message: 'Period successfully planned' });
        }, (err) => {
          _this.vacationSaveProcess = false;
          for (const i in err.response.data.data) {
            _this.showErrorMsg({ title: 'Planned period create status', message: err.response.data.data[i] });
          }
        });
      } else {
        this.newVacation.starts_at = moment(this.newVacation.starts_at).format('YYYY-MM-DD');
        this.newVacation.ends_at = moment(this.newVacation.ends_at).format('YYYY-MM-DD');
        this.CREATE_PLANNED_PROJECT_MATERIALS(this.newVacation).then((response) => {
          _this.vacationSaveProcess = false;
          _this.newVacation = {
            type: null,
            project_id: _this.projectId || null,
            user_id: null,
            starts_at: null,
            ends_at: null,
            coefficient: null,
            materialName: '',
          };
          _this.showSuccessMsg({ title: 'Planned materials create status', message: 'Materials successfully planned' });
        }, (err) => {
          _this.vacationSaveProcess = false;
          for (const i in err.response.data.data) {
            _this.showErrorMsg({ title: 'Planned materials create status', message: err.response.data.data[i] });
          }
        });
      }
    },
    openEditVacation(id) {
      this.editVacation = { ...this.plannedVacations[id] };
      this.calculateVacationExpenses(this.editVacation);
      this.editVacationModal = true;
    },
    saveVacation() {
      const _this = this;
      this.editVacation.starts_at = moment(this.editVacation.starts_at).format('YYYY-MM-DD');
      this.editVacation.ends_at = moment(this.editVacation.ends_at).format('YYYY-MM-DD');
      this.CREATE_PLANNED_VACATION(this.editVacation).then(() => {
        _this.showSuccessMsg({ title: 'Planned vacation update status', message: 'Vacation successfully updated' });
      }, (err) => {
        _this.showErrorMsg({ title: 'Planned vacation update status', message: err.message });
      });
      this.editVacationModal = false;
    },
    deleteVacation(id) {
      this.DELETE_PLANNED_VACATION(id).then(() => {

      });
    },
    calculateAllVacationsExpenses() {
      this.tableTotal = {
        hours: 0,
        costs: 0
      };
      for (const vacation in this.plannedVacations) {
        if (this.projectId) {
          if (this.projectId == this.plannedVacations[vacation].project_id) {
            if (this.filterDate.start || this.filterDate.end) {
              if (this.plannedVacations[vacation].ends_at <= moment(this.filterDate.end).format('YYYY-MM-DD') && this.plannedVacations[vacation].starts_at >= moment(this.filterDate.start).format('YYYY-MM-DD')) {
                var expenses = this.calculateVacationExpenses(this.plannedVacations[vacation], 'table');
                this.plannedVacations[vacation].hours = expenses.hours;
                this.plannedVacations[vacation].costs = expenses.costs;
                this.tableTotal.hours += expenses.hours;
                this.tableTotal.costs += expenses.costs;
              }
            } else {
              var expenses = this.calculateVacationExpenses(this.plannedVacations[vacation], 'table');
              this.plannedVacations[vacation].hours = expenses.hours;
              this.plannedVacations[vacation].costs = expenses.costs;
              this.tableTotal.hours += expenses.hours;
              this.tableTotal.costs += expenses.costs;
            }
          }
        } else if (this.filterDate.start || this.filterDate.end) {
          if (this.plannedVacations[vacation].ends_at <= moment(this.filterDate.end).format('YYYY-MM-DD') && this.plannedVacations[vacation].starts_at >= moment(this.filterDate.start).format('YYYY-MM-DD')) {
            var expenses = this.calculateVacationExpenses(this.plannedVacations[vacation], 'table');
            this.plannedVacations[vacation].hours = expenses.hours;
            this.plannedVacations[vacation].costs = expenses.costs;
            this.tableTotal.hours += expenses.hours;
            this.tableTotal.costs += expenses.costs;
          }
        } else {
          var expenses = this.calculateVacationExpenses(this.plannedVacations[vacation], 'table');
          this.plannedVacations[vacation].hours = expenses.hours;
          this.plannedVacations[vacation].costs = expenses.costs;
          this.tableTotal.hours += expenses.hours;
          this.tableTotal.costs += expenses.costs;
        }
      }
    },
    calculateVacationExpenses(vacation, type) {
      const _this = this;
      if (!vacation.project_id || !vacation.user_id || !vacation.starts_at || !vacation.ends_at || !vacation.coefficient) {
        _this.showErrorMsg({ title: 'Calculate vacation expenses', message: 'All fields are obligated!' });
        return;
      }
      const startDate = new Date(vacation.starts_at);
      const endDate = new Date(vacation.ends_at);
      let days = 0;
      let hours = 0;
      let cost = 0;
      while (startDate <= endDate) {
        if (moment(startDate).isoWeekday() != 6 && moment(startDate).isoWeekday() != 7) {
          let specialDay = '';
          for (const i in _this.specialBusinessDays) {
            if (_this.specialBusinessDays[i].date == moment(startDate).format('YYYY-MM-DD')) {
              specialDay = _this.specialBusinessDays[i];
            }
          }
          if (specialDay && specialDay.delta_time == 8) {
            startDate.setDate(startDate.getDate() + 1);
            continue;
          }
          days++;
          let workingHours = 0;
          if (specialDay) {
            workingHours = specialDay.delta_time * vacation.coefficient;
          } else {
            workingHours = 8 * vacation.coefficient;
          }
          hours += workingHours;
          cost += (workingHours * _this.ratesOnDate(moment(startDate).format('YYYY-MM-DD'), vacation.user_id));
        }
        startDate.setDate(startDate.getDate() + 1);
      }
      if (type == 'table') {
        return {
          hours: hours,
          costs: cost
        };
      }
      if (!vacation.id) {
        _this.newVacationExpenses = `${hours.toFixed(2)} h / ${cost.toFixed(2)} €`;
      } else {
        _this.editVacationExpenses = `${hours.toFixed(2)} h / ${cost.toFixed(2)} €`;
      }
    },
    showVacation(vacation) {
      if (this.filterDate.start || this.filterDate.end) {
        return (!this.projectId && vacation.ends_at <= moment(this.filterDate.end).format('YYYY-MM-DD') && vacation.starts_at >= moment(this.filterDate.start).format('YYYY-MM-DD')) || (vacation.project_id == this.projectId && vacation.ends_at <= moment(this.filterDate.end).format('YYYY-MM-DD') && vacation.starts_at >= moment(this.filterDate.start).format('YYYY-MM-DD'));
      }
      return !this.projectId || vacation.project_id == this.projectId;
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  },
  mounted() {
    this.LOAD_PLANNED_VACATIONS();
  },
};

</script>

<style lang="scss" scoped>
    .compact * {
        padding: 0;
    }
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }
    .currency::after{
        content: " €";
    }
    .hours::after{
        content: " h";
    }
    .total-costs-row {
        font-weight: bold;
    }

</style>
<style>
    .new-vacation-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.5rem 0.75rem;
    }
</style>
